var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.article
      ? _c(
          "a",
          {
            staticClass: "flex flex-col bg-white h-full",
            attrs: { href: _vm.article.link }
          },
          [
            _c("div", {
              staticClass:
                "lg:h-[343px] lg:h-[658px] lg:h-[688px] lg:h-[249px] hidden"
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "lazyload w-full object-cover h-[250px]",
              class: [
                _vm.imageHeight !== "auto"
                  ? "lg:h-[" + _vm.imageHeight + "px]"
                  : "lg:h-full"
              ],
              attrs: {
                src: _vm.article.acf.image.url,
                alt: _vm.article.acf.image.alt
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "p-[30px]" },
              [
                _vm.article.date
                  ? _c(
                      "div",
                      { staticClass: "text-14 mb-[5px] font-regular" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(_vm.article.date, "DD-MM-YYYY")
                          )
                        )
                      ]
                    )
                  : _vm.article.post_date
                  ? _c(
                      "div",
                      { staticClass: "text-14 mb-[5px] font-regular" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.article.post_date,
                              "DD-MM-YYYY"
                            )
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.clamp
                  ? _c("v-clamp", {
                      staticClass:
                        "text-26 tracking-normal text-orange font-bold h-[57px] xl:h-[53px] mb-16  overflow-ellipsis",
                      attrs: { autoresize: "", "max-lines": 3 },
                      domProps: { innerHTML: _vm._s(_vm.articleTilte) }
                    })
                  : _c("div", {
                      staticClass:
                        "text-26 tracking-normal text-orange font-bold mb-16  overflow-ellipsis",
                      domProps: { innerHTML: _vm._s(_vm.articleTilte) }
                    }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "justify-center group flex-wrap px-[25px] py-[14px] flex items-center gap-8 font-semi rounded-full hover:opacity-80 transition-opacity !bg-orange !text-white"
                  },
                  [_vm._v("Lees meer")]
                )
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }